import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projects: [],
};

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    storeProjects: (state, { payload }) => {
      state.projects = payload;
    },
  },
});

export const { storeProjects } = projectsSlice.actions;

export default projectsSlice.reducer;
